export default __webpack_public_path__ + "static/media/photo--sm--kickoff7.c980bf0a.jpg";